import { render, staticRenderFns } from "./applicant-information.vue?vue&type=template&id=a1a2d2fe&lang=pug&"
import script from "./applicant-information.vue?vue&type=script&lang=js&"
export * from "./applicant-information.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VForm,VRow,VSelect,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/home/udo/Projects/nakami/gvl/gvl-neustart/gvl-neustart-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a1a2d2fe')) {
      api.createRecord('a1a2d2fe', component.options)
    } else {
      api.reload('a1a2d2fe', component.options)
    }
    module.hot.accept("./applicant-information.vue?vue&type=template&id=a1a2d2fe&lang=pug&", function () {
      api.rerender('a1a2d2fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/applicant-information.vue"
export default component.exports